export default function isHiragana(str){
  // var str = "あいうえおわいうえおん";
  if (str.match(/^[\u3040-\u309F]+$/)) {
    return true;
  } else {
    return false;
  }
}
